import * as React from "react";
import type { SVGProps } from "react";
const SvgMail03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m3.6 6.104 8.4 6.6 9-6.6m-12 6.5-5.4 5.5m16.8-.5-6-5.5m-9.6 6.992a2.4 2.4 0 0 1-2.4-2.4V7.304a2.4 2.4 0 0 1 2.4-2.4h14.4a2.4 2.4 0 0 1 2.4 2.4v9.392a2.4 2.4 0 0 1-2.4 2.4z"
    />
  </svg>
);
export default SvgMail03;
